// A fish, modelled facing +X: a stretched body with a flat triangular tail fin
// at the -X end. Ported 1:1 from age-of-mcp's classic fish.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.026, 0),
      color: "#1c5e8b", position: [0, 0.026, 0], scale: [1.8, 0.9, 0.7] },
    { geometry: new THREE.ConeGeometry(0.022, 0.035, 3),
      color: "#103e60", position: [-0.05, 0.026, 0],
      rotation: [0, 0, Math.PI / 2], scale: [1, 1, 0.3] },
  ];
}

export const fish = defineModel({
  id: "fish",
  batchId: "standard",
  name: "Fish",
  tags: ["creature","fish","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly fish.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: () => partsFor(),
  animations: [],
});
